import { h, Fragment } from "preact";
import { useState } from "preact/hooks";
import { Card, Typography } from "antd";
import APITab from "./tabs/APITab/APITab";
import WebhooksTab from "./tabs/WebhooksTab/WebhooksTab";

export default function SettingsPage(props) {
  const [selectedTab, setSelectedTab] = useState("API");

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };

  const renderTab = () => {
    switch (selectedTab) {
      case "API":
        return <APITab />;
      case "Webhooks":
        return <WebhooksTab />;
      case "Roles":
        break;
      case "Rules":
        break;
      case "Appearance":
        break;
      case "General":
        break;
      default:
        return <APITab />;
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ display: "flex", columnGap: "0.5px" }}>
        <div
          className={`settings-tab ${selectedTab === "API" ? "selected" : ""}`}
          onClick={() => handleTabClick("API")}
        >
          <h4
            className={`settings-tab-text ${
              selectedTab === "API" ? "selected" : ""
            }`}
          >
            API
          </h4>
        </div>
        <div
          className={`settings-tab ${
            selectedTab === "Webhooks" ? "selected" : ""
          }`}
          onClick={() => handleTabClick("Webhooks")}
        >
          <h4
            className={`settings-tab-text ${
              selectedTab === "Webhooks" ? "selected" : ""
            }`}
          >
            Webhooks
          </h4>
        </div>
        {/* <div
          className={`settings-tab ${
            selectedTab === "Roles" ? "selected" : ""
          }`}
          onClick={() => handleTabClick("Roles")}
        >
          <h4
            className={`settings-tab-text ${
              selectedTab === "Roles" ? "selected" : ""
            }`}
          >
            Roles
          </h4>
        </div>
        <div
          className={`settings-tab ${
            selectedTab === "Rules" ? "selected" : ""
          }`}
          onClick={() => handleTabClick("Rules")}
        >
          <h4
            className={`settings-tab-text ${
              selectedTab === "Rules" ? "selected" : ""
            }`}
          >
            Rules
          </h4>
        </div>
        <div
          className={`settings-tab ${
            selectedTab === "Appearance" ? "selected" : ""
          }`}
          onClick={() => handleTabClick("Appearance")}
        >
          <h4
            className={`settings-tab-text ${
              selectedTab === "Appearance" ? "selected" : ""
            }`}
          >
            Appearance
          </h4>
        </div>
        <div
          className={`settings-tab ${
            selectedTab === "General" ? "selected" : ""
          }`}
          onClick={() => handleTabClick("General")}
        >
          <h4
            className={`settings-tab-text ${
              selectedTab === "General" ? "selected" : ""
            }`}
          >
            General
          </h4>
        </div> */}
      </div>
      <Card
        bordered={false}
        style={{ borderRadius: "0px 0px 16px 16px", padding: "45px 25px" }}
      >
        {renderTab()}
      </Card>
    </div>
  );
}
